(function ($) {
  $(function () {
    $(document).ready(function () {

      if (window.location.hash) {
        setTimeout(function() {
          $('html, body').scrollTop(0).delay(2000); //Czas po ilu sekundach po wejściu na stronę na scrollować w dół
          $('html, body').animate({
            scrollTop: $(window.location.hash).offset().top - 100 // Offset od elementu, bez offsetu zostawić ".top"
          }, 1500) // Szybkośc animacji 
        }, 0);
      }

      if( matchMedia('(min-width: 742px)').matches ) {
        $( " .certification-item " ).each(function( index ) {
          var get_height = $( this ).find('.certification-item-text h3').outerHeight();
          get_height+=30;
          $( this ).find( '.certification-item-logo' ).css( 'padding-top', get_height+'px' );
        });
      }
      

     

      

        // GSAP scroll trigger for changing slides
        gsap.registerPlugin(ScrollTrigger);
      
        var swiper_accordion_mobile = new Swiper(".swiper_accordion_mobile", {
          slidesPerView: 1,
          spaceBetween: 20,
      
          pagination: { 
            clickable: true,
            el: ".swiper-pagination",
          },
          on: {
            slideChange: function(index) {
              var indexAccordion = swiper_accordion_mobile.realIndex;
              indexAccordion++;
              $(".accordion_with_slider_mobile.slider_on_mobile .slider_on_mobile_wrapper")
              .find(".active")
              .removeClass("active");
              $(".accordion_with_slider_mobile.slider_on_mobile .slider_on_mobile_wrapper .slider_single_title[accordionid="+indexAccordion+"]").addClass('active')
            
            },
          },
        });

        $(".accordion_with_slider_mobile.slider_on_mobile .slider_on_mobile_wrapper .slider_single_title ").click(function () {
          $(".accordion_with_slider_mobile.slider_on_mobile .slider_on_mobile_wrapper")
            .find(".active")
            .removeClass("active");
          var ClickedAccordion = $(this).attr("accordionId");
          $(this).addClass("active");

    
          var swiperChange = ClickedAccordion - 1;
          swiper_accordion_mobile.slideTo(swiperChange, 500, false);
        });


        if( matchMedia('(min-width: 800px)').matches ) {
          if( $( '.accordion_with_slider' ).length > 0 ) {
            var swiper_accordion = new Swiper(".accordion_with_slider  .swiper_accordion", {
              slidesPerView: 1,
              spaceBetween: 20,
              noSwiping: false,
              allowTouchMove: false,
              pagination: { 
       
                el: ".swiper_accordion .swiper-pagination",
              },
            });
          
            $(".accordion_with_slider  .accordion .accordion__single ").click(function () {
              $(".accordion_with_slider  .accordion_header_wrapper")
                .find(".accordion__open")
                .removeClass("accordion__open");
              $(".accordion_with_slider  .accordrion_body_wrapper")
                .find(".accordion__open")
                .removeClass("accordion__open");
              var ClickedAccordion = $(this).attr("accordionId");
              $(this).addClass("accordion__open");
              $(".accordion_with_slider  .accordrion_body_wrapper")
                .find('.accordion__single[accordionId="' + ClickedAccordion + '"]')
                .addClass("accordion__open");
              var swiperChange = ClickedAccordion - 1;
              swiper_accordion.slideTo(swiperChange, 500, false);
            });
          
          
            var slides = document.querySelectorAll('.accordion_with_slider .swiper_accordion .swiper-slide');
          
            ScrollTrigger.create({
              trigger: '.accordion_with_slider',
              start: 'top top',
              endTrigger: '.accordion_with_slider',
              end: '+=1500', 
              pin: true,
              pinType: "fixed",
              scrub: 1,
              onUpdate: function (self) {
                var progress = self.progress;
                var targetSlide = Math.round(progress * (slides.length - 1));
                //swiper_accordion.slideTo(targetSlide);
                targetSlide++;
                $(".accordion_with_slider  .accordion_header_wrapper")
                .find(".accordion__open")
                .removeClass("accordion__open");
              $(".accordion_with_slider  .accordrion_body_wrapper")
                .find(".accordion__open")
                .removeClass("accordion__open");
                
             
              $('.accordion_with_slider  .accordion_header_wrapper .accordion__single[accordionid="' + targetSlide + '"]').addClass("accordion__open").click();
              $(".accordion_with_slider  .accordrion_body_wrapper")
                .find('.accordion__single[accordionId="' + targetSlide + '"]')
                .addClass("accordion__open");
          
          
              }
            });
          
          }
          }
          




      // slider_title_and_image

  if( $( '.slider_title_and_image' ).length > 0 ) {
    var swiper_title_and_image = new Swiper(".slider_title_and_image   .swiper_title_and_image", {
      slidesPerView: 1,
      spaceBetween: 20,
      noSwiping: false,
      allowTouchMove: false,
      pagination: {
        el: ".swiper_title_and_image .swiper-pagination",
      },
    });



    var slides3 = document.querySelectorAll('.swiper_title_and_image .swiper-slide');


    ScrollTrigger.create({
      trigger: '.slider_title_and_image',
      start: 'top top',
      endTrigger: '.slider_title_and_image',
      end: '+=1500',
      pin: true,
      pinType: "fixed",
      scrub: 1,
      onUpdate: function (self) {
        var progress3 = self.progress;
        var targetSlide3 = Math.round(progress3 * (slides3.length - 1));
       
       
        $(".slider_title_and_image  .accordion_header_wrapper")
      .find(".accordion__open")
      .removeClass("accordion__open");
        $(".slider_title_and_image   .accordion_header_wrapper")
      .find('.accordion__single[data-slide="' + targetSlide3 + '"]')
      .addClass("accordion__open");

        swiper_title_and_image.slideTo(targetSlide3);
      }
    });
  }
//slider_image_with_description 
  if( $( '.slider_image_with_description' ).length > 0 ) {
    var swiper_image = new Swiper(".swiper_image", {
      slidesPerView: 1,
      spaceBetween: 30,
      pagination: {
        el: ".swiper_image .swiper-pagination",
        clickable: true,
      },
    });

    var slides2 = document.querySelectorAll(".slider_image_with_description .swiper_image .swiper-slide");


    ScrollTrigger.create({
      trigger: ".slider_image_with_description",
      start: "top 0",
      endTrigger: ".slider_image_with_description",
      end: "+=1000",
      pin: true,
      pinType: "fixed",
   
      scrub: 1,
      onUpdate: function (self) {
        var progress2 = self.progress;
        var targetSlide2 = Math.round(progress2 * (slides2.length - 1));

        swiper_image.slideTo(targetSlide2);
      },
    });
  }



      // dynamic navigation
   if($(".scroll_item").length > 0) {
    $(".scroll_item").each(function (i) {
      var idValueDisplay = $(this).attr("scroll-item");

      if (idValueDisplay.length > 0) {
        if (i == 0) {
          $(".sticky_navigation .wrapper").append(
            '<a class="active single_nav" href="' +
              idValueDisplay +
              '">' +
              idValueDisplay +
              "</a>"
          );
        } else {
          $(".sticky_navigation .wrapper").append(
            '<a class="single_nav" href="' +
              idValueDisplay +
              '">' +
              idValueDisplay +
              "</a>"
          );
        }
      } else {
      }
    });
    //Scroll do sekcji na podstawie dolnej krawędzi wcześniejszego elementu
    $(".sticky_navigation .single_nav").on("click", function (e) {
      e.preventDefault();
      var target = $(this).attr("href");
      var targetSibling = $('.scroll_item[scroll-item="' + target + '"]');
      $("html, body").animate(
        {
          scrollTop: $(targetSibling).offset().top,
        },
        1000
      );
    });

    /**Dodawanie klasy active dla wcześniej stworzonego menu bocznego na podstawie sekcji która jest aktualnie wyświetlana  */
    $(window)
      .scroll(function () {
        var scrollDistance = $(window).scrollTop();

        // Assign active class to nav links while scolling
        $(".scroll_item").each(function (i) {
          if ($(this).offset().top / 1.05 <= scrollDistance) {
            var thisScrollItem = $(this).attr("scroll-item");
            if (thisScrollItem.length > 0) {
              $(".sticky_navigation .single_nav.active").removeClass(
                "active"
              );
              $(
                '.sticky_navigation .single_nav[href="' +
                  thisScrollItem +
                  '"]'
              ).addClass("active");
            } else {
              $(".sticky_navigation .single_nav.active").removeClass(
                "active"
              );
            }
          }
        });
      })
      .scroll();
   }
    });

 
    var swiper_icon = new Swiper(".swiper_icon", {
      slidesPerView: 'auto',
      spaceBetween: 30,
      freemode: true,
      speed: 1500,
      autoplay: {
          delay: 1300,
          disableOnInteraction: false,
        },
    });

  
// description_slider_icon
if( matchMedia('(min-width: 568px)').matches ) {
  var nextArrow = $(".description_and_slider_icon .slider .swiper-button-next");
  var prevArrow = $(".description_and_slider_icon .slider .swiper-button-prev");
  $(".swiper_description_slider_icon").each(function (index) {
    var swiper_description_slider_icon = new Swiper($(this)[0], {
      slidesPerView: 4,
      spaceBetween: 70,
     
   
      navigation: {
        nextEl: nextArrow[index],
        prevEl: prevArrow[index],
      },
      breakpoints: {
        240: {
          slidesPerView: "auto",
          spaceBetween: 20,
        },
        768: {
          slidesPerView: "auto",
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 70,
        },
        1440: {
          slidesPerView: 4,
          spaceBetween: 70,
        },
      },
    });
  });

  }

    /*****
      iOS Viewport check
    *****/
    var isVHCheckNeeded = vhCheck();
    var hasVHCKeckValue =
      document.documentElement.style.getPropertyValue("--vh-offset");
    if (isVHCheckNeeded && hasVHCKeckValue) {
      $("body").addClass("use-ios-offset");
    }

    /*****
      RWD Videos
    *****/
    $(".nice-type").fitVids();

    /*****
      Parallax
    *****/
    var winScrollTop = 0;
    $.fn.is_on_screen = function () {
      var win = $(window);
      var viewport = {
        top: win.scrollTop(),
        left: win.scrollLeft(),
      };
      viewport.bottom = viewport.top + win.height();
      var bounds = this.offset();
      bounds.bottom = bounds.top + this.outerHeight();
      return !(viewport.bottom < bounds.top || viewport.top > bounds.bottom);
    };

    function parallax() {
      $(".rellax").each(function () {
        if ($(this).is_on_screen()) {
          var firstTop = $(this).offset().top;
          var speed = $(window).width() > 700 ? 0.1 : 0.07;
          var moveTop = (firstTop - winScrollTop) * speed;
          $(this).css("transform", "translateY(" + -moveTop + "px)");
        }
      });
    }

    $(window).scroll(function (e) {
      winScrollTop = $(this).scrollTop();
      parallax();
    });

    /*****
      Number counter
    *****/
    var MutationObserver =
      window.MutationObserver ||
      window.WebKitMutationObserver ||
      window.MozMutationObserver;
    $.fn.attrchange = function (callback) {
      if (MutationObserver) {
        var options = {
          subtree: false,
          attributes: true,
        };

        var observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (e) {
            callback.call(e.target, e.attributeName);
          });
        });

        return this.each(function () {
          observer.observe(this, options);
        });
      }
    };

    var count_elems = $("[data-dots-count]");
    count_elems.each(function () {
      var parent = $(this).parents(".dots-block-item");
      var end = $(this).attr("data-dots-count");
      var numAnim = new countUp.CountUp($(this)[0], end);

      parent.attrchange(function (attrName) {
        if (attrName == "class") {
          var attributeValue = parent.attr("class");
          var classes = attributeValue.split(" ");
          if (classes.indexOf("is-animating") > -1) {
            numAnim.start();
          }
        }
      });
    });

    /*****
      ScrollReveal
    *****/
    window.sr = ScrollReveal({
      viewOffset: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
      },
      opacity: 0,
      scale: 1,
      cleanup: false,
      beforeReveal: function (el) {
        el.classList.add("is-animating");
      },
      afterReveal: function (el) {
        el.classList.remove("is-animating");
        el.classList.add("has-animated");
        $(el).removeAttr("data-sr");
        $(el).removeAttr("data-sr-id");
        $(el).removeAttr("style");
      },
    });

    function re_init_scroll_reveal() {
      sr.reveal('[data-sr="fade-slide-down"]', {
        distance: "15px",
        origin: "top",
        delay: 100,
        duration: 450,
        easing: "ease",
      });

      sr.reveal('[data-sr="fade-slide-right"]', {
        distance: "15px",
        origin: "right",
        delay: 100,
        duration: 450,
        easing: "ease",
      });

      sr.reveal('[data-sr="fade-slide-left-chain"]', {
        distance: "15px",
        origin: "left",
        delay: 100,
        duration: 450,
        easing: "ease",
        interval: 300,
      });

      sr.reveal('[data-sr="fade-slide-right-chain"]', {
        distance: "15px",
        origin: "right",
        delay: 100,
        duration: 450,
        easing: "ease",
        interval: 100,
      });

      sr.reveal('[data-sr="fade-slide"]', {
        distance: "15px",
        origin: "bottom",
        delay: 100,
        duration: 450,
        easing: "ease",
      });

      sr.reveal('[data-sr="fade-slide-chain"]', {
        distance: "15px",
        origin: "bottom",
        delay: 100,
        interval: 50,
        duration: 450,
      });
    }

    if ($("[data-sr]").length) {
      re_init_scroll_reveal();
    }

    /*****
      Nav toggle
    *****/
    $(".site-menu-toggle").on("click", function (e) {
      e.preventDefault();
      $(this).toggleClass("is-active");
      $("html").attr(
        "data-nav-state",
        $("html").attr("data-nav-state") == "closed" ? "open" : "closed"
      );
    });

    /*****
      Nav toggle
    *****/
    $(".menu-item-has-children svg").on("click", function (e) {
      e.preventDefault();
      $(this).parents("li").toggleClass("is-open");
      $(this).next(".sub-menu").slideFadeToggle(300);
    });

    /*****
      Fixed header
    *****/
    var headroom_args = {
      offset: 100,
      tolerance: 10,
    };
    var header = document.querySelector(".site-header");
    var header_headroom = new Headroom(header, headroom_args);
    header_headroom.init();

    var body = document.querySelector("body");
    var body_headroom = new Headroom(body, headroom_args);
    body_headroom.init();

    function headroom_freeze() {
      // console.log('headroom_freeze');
      header_headroom.freeze();
      body_headroom.freeze();
    }

    function headroom_unfreeze() {
      // console.log('headroom_unfreeze');
      header_headroom.unfreeze();
      body_headroom.unfreeze();
    }

    function headroom_hide() {
      // console.log('headroom_hide');
      header_headroom.unpin();
      body_headroom.unpin();
    }

    /*****
      Sticky bar nav
    *****/
    if ($(".sticky-bar-nav").length) {
      // Handle active states
      function do_sector_section_active_nav() {
        var sector_sections = mostVisible("[data-sticky-section]");
        var sector_section_name = $(sector_sections).attr(
          "data-sticky-section"
        );

        var current = $(".sticky-bar-nav a.active");
        var next = $(
          '.sticky-bar-nav [data-sticky-target="' + sector_section_name + '"]'
        );

        if (next !== current) {
          current.removeClass("active");
          next.addClass("active");
        }
      }

      // Attach the events for active nav states
      $(window).on(
        "scroll",
        $.throttle(120, function () {
          do_sector_section_active_nav();
        })
      );
      do_sector_section_active_nav();

      // Handle nav clicks
      $("[data-sticky-target]").on("click", function (e) {
        e.preventDefault();

        headroom_hide();

        var sector_section_id = $(this).attr("href").replace("#", "");
        var target = $("#" + sector_section_id);
        var target_offset = target.offset().top - 20;

        headroom_freeze();
        $("html, body")
          .stop(true, false)
          .animate({ scrollTop: target_offset }, 400, function () {
            headroom_unfreeze();
          });
      });
    }

    /*****
      Toggle the 'get in touch' form
    *****/
    $(".get-in-touch-top.has-toggle").on("click", function (e) {
      e.preventDefault();
      $(this).find(".get-in-touch-toggle").toggleClass("active");
      $(".get-in-touch-bottom").slideFadeToggle();
    });

    if ($(".get-in-touch-top.has-toggle").length) {
      if (location.href.indexOf("#form") != -1) {
        $(".get-in-touch-top.has-toggle")
          .find(".get-in-touch-toggle")
          .addClass("active");
        $(".get-in-touch-bottom").slideFadeIn();
        history.replaceState(null, null, " ");
        setTimeout(function () {
          $("html, body")
            .stop(true, false)
            .animate({ scrollTop: $(".get-in-touch").offset().top }, 300);
        }, 200);
      }
    }

    /*****
      Toggle the 'FAQ' section
    *****/
    // $('.faq-block-top').on('click', function (e) {
    //   e.preventDefault();
    //   $(this).find('.faq-block-toggle').toggleClass('active');
    //   $('.faq-block-bottom').slideFadeToggle();
    // });

    $(document).on("gform_confirmation_loaded", function (event, formId) {
      var url = $(
        '#post-download-form-success[data-form-id="' + formId + '"]'
      ).attr("data-src");
      if (url) {
        setTimeout(function () {
          window.open(url, "_blank");
        }, 1000);
      }
    });

    /*****
      Append a grid-view toggle, but only locally
    *****/
    $("body.is-local").append(
      '<div id="toggle-grid" style="position: fixed; bottom: 10px; left: 10px; cursor: pointer; box-shadow: 0 0 10px rgba(0, 0, 0, 0.5); border-radius: 10px; background: white; color: black; font-weight: bold; font-size: 18px; padding: 5px 8px; z-index: 1000;">Grid</div>'
    );
    $(document).on("click", ".is-local #toggle-grid", function (e) {
      e.preventDefault();
      $("body").toggleClass("grid-view");
    });

    if ($("[data-accordion]").length) {
      $("[data-accordion-item-toggle]").on("click", function () {
        var accordion_parent = $(this).parents("[data-accordion]");
        var scroll_on_open = accordion_parent[0].hasAttribute(
          "data-accordion-scroll-on-open"
        )
          ? true
          : false;

        var this_item = $(this).parents("[data-accordion-item]");
        if (this_item.attr("data-accordion-item") == "open") {
          // console.log('Closing');
          this_item.attr("data-accordion-item", "");
          this_item.find("[data-accordion-item-content]").slideUp(300);
        } else {
          // console.log('Opening');
          var other_items = $(this)
            .parents("[data-accordion]")
            .find('[data-accordion-item="open"]')
            .not(this_item);
          var other_items_content = other_items.find(
            "[data-accordion-item-content]"
          );
          var this_content = $(this).next("[data-accordion-item-content]");
          this_item.attr("data-accordion-item", "open");
          other_items.attr("data-accordion-item", "");
          this_content.slideDown(300);
          other_items_content.slideUp(300);

          if (scroll_on_open) {
            $("html, body")
              .stop(true, false)
              .animate({ scrollTop: this_item.offset().top + 1 }, 300);
          }
        }
      });

      $("[data-accordion]").each(function () {
        var accordion_start_val = ~~$(this).attr("data-accordion");
        if (
          accordion_start_val > 0 &&
          $(this).find("[data-accordion-item]").length > accordion_start_val
        ) {
          $(this)
            .find("[data-accordion-item]")
            .eq(accordion_start_val - 1)
            .find("[data-accordion-item-toggle]")
            .click();
        }
      });
    }

    if ($("[data-faq-slug]").length) {
      var windowHash = window.location.hash.replace("#", "");
      var faqWrapper = $('[data-faq-slug="' + windowHash + '"]');
      var itemWrapper = $('[data-accordion-item-slug="' + windowHash + '"]');
      var stickyBarHeight = $(".sticky-bar-nav").height();

      if (windowHash && faqWrapper.length && !itemWrapper.length) {
        headroom_hide();
        headroom_freeze();
        faqWrapper.find(".faq-block-top").click();
        history.replaceState(null, null, " ");
        setTimeout(function () {
          $("html, body")
            .stop(true, false)
            .animate(
              { scrollTop: faqWrapper.offset().top - stickyBarHeight },
              300
            );
        }, 310);
        setTimeout(function () {
          headroom_unfreeze();
        }, 610);
      } else if (windowHash && itemWrapper.length) {
        headroom_hide();
        headroom_freeze();
        faqWrapper = itemWrapper.parents(".faq-block");
        faqWrapper.find(".faq-block-top").click();
        setTimeout(function () {
          itemWrapper.find("[data-accordion-item-toggle]").click();
        }, 100);
        history.replaceState(null, null, " ");
        setTimeout(function () {
          $("html, body")
            .stop(true, false)
            .animate(
              { scrollTop: faqWrapper.offset().top - stickyBarHeight },
              300
            );
        }, 310);
        setTimeout(function () {
          headroom_unfreeze();
        }, 610);
      }
    }
  });
})(jQuery);
